import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { NavLink } from '../models/interfaces/nav-link.model';
import { LinkDisplayType } from '../models/enums/link-display-type.enum';

@Injectable({
    providedIn: 'root'
})
export class UiService {
    loadingStateChanged = new Subject<boolean>();
    routeLoadingStateChanged = new Subject<boolean>();
    translationLoadingStateChanged = new Subject<boolean>();
    pageTitleChanged = new Subject<string>();

    constructor(
        private snackbar: MatSnackBar,
        private translateSrv: TranslateService
    ) { }

    showSnackbar(message: string, action: string, duration = 3000, isTranslated = false): void {
        if(isTranslated) {
            this.translateSrv.get(message).subscribe(text => {
                this.snackbar.open(text, action, { duration: duration });
            });
        } else {
            this.snackbar.open(message, action, { duration: duration });
        }
    }

    changeTitle(text: string, isTranslated = true): void {
        if(isTranslated) {
            this.translateSrv.get(text)
            .subscribe(result => {
                this.pageTitleChanged.next(result);
            });
        } else {
            this.pageTitleChanged.next(text);
        }
    }

    translate(key: string): string {
        return this.translateSrv.instant(key);
    }

    getInfoLinks(): NavLink[] {
        return [
            {
                route: "/help",
                icon: "contact_support",
                title: "main.nav.links.help.shortLabel",
                linkLabel: "main.nav.links.help.fullLabel",
                content: "main.nav.links.help.summary",
                display: LinkDisplayType.all
            }
        ];
    }

    getChartsColors(): string[] {
        return [
            '#af1e3c',
            '#faafa0',
            '#dc1e5f',
            '#ffdae1',
            '#f03241',
            '#979faa',
            '#8c193c',
            '#ebebe6',
            '#5a0037',
            '#e8ebed',
            '#d2d2d7',
        ];
    }

    lightenHexColor(colorWithTag, percent): string {
        const color = colorWithTag.substring(1);
        const num = parseInt(color, 16),
        amt = Math.round(2.55 * percent),
        /* tslint:disable:no-bitwise */
        R = (num >> 16) + amt,
        B = (num >> 8 & 0x00FF) + amt,
        G = (num & 0x0000FF) + amt;
        /* tslint:enable:no-bitwise */

        return "#" + (0x1000000
            + (R < 255 ? R < 1 ? 0 : R : 255)
            * 0x10000
            + (B < 255 ? B < 1 ? 0 : B : 255)
            * 0x100
            + (G < 255 ? G < 1 ? 0 : G : 255))
            .toString(16)
            .slice(1);
    }
}
